export default "__VITE_ASSET__Bnva1SLK__"